import React, { useEffect, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";
import { Button } from "semantic-ui-react";
import { Result, message } from "antd";
import axios from "axios";
import jwt from "jsonwebtoken";

function EmployeeInvitation(props) {
  const [query, setQuery] = useState({});
  const { search } = useLocation();
  const { empId, schoolId } = useParams();
  const history = useHistory();
  const searchQuery = queryString.parse(search);

  const [loading, setLoading] = useState(false);
  const [answer, setAnswer] = useState(false);

  useEffect(() => {
    const q = localStorage.getItem("query");
    setQuery(JSON.parse(q));
  }, []);

  const handleAnswer = async (status) => {
    try {
      // get token from storage
      const token = localStorage.getItem("token");
      const user = jwt.verify(token, "success");
      // set loading to true
      setLoading(true);
      console.log(answer);
      // call api
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/employees/invitation/${empId}?status=${status}`,
        { headers: { token } }
      );
      // if status === 200
      if (response.status === 200) {
        setLoading(false);
        message.success(response.data.message);
        return history.push(
          status === "accepted"
            ? `/dashboard/s/${schoolId}`
            : `/user/${user.uuid}`
        );
      }
      // return a success message
    } catch (error) {
      setLoading(false);
      if (error.message === "Network Error") {
        message.error(error.message);
      }
      if (error?.response?.status === 403) {
        return message.error(error.response.data.error);
      }
      if (error?.response?.status === 404) {
        return message.error(error.response.data.error);
      }
      return error;
    }
  };

  return (
    <Result
      title='New Invitation'
      subTitle={
        <p>
          You have a new invitation to join the school:{" "}
          <strong>{searchQuery?.schoolName || query?.schoolName} </strong> as a{" "}
          <strong>{searchQuery?.role || query?.role}</strong>{" "}
        </p>
      }
      extra={
        <>
          <Button
            circular
            content='Accept'
            positive
            loading={loading && answer}
            onClick={() => {
              setAnswer(true);
              handleAnswer("accepted");
            }}
          />
          <Button
            circular
            content='Reject'
            negative
            basic
            loading={loading && !answer}
            onClick={() => {
              setAnswer(false);
              handleAnswer("rejected");
            }}
          />
        </>
      }
    />
  );
}

export default EmployeeInvitation;
